module.exports = __webpack_public_path__ + "static/media/stagiaire.ee019001.jpg";